/** Обратный отсчёт до момента `until` (мс эпохи) — целые секунды, не меньше нуля. */
export function secondsLeft(until: number, now: number): number {
	return Math.max(0, Math.ceil((until - now) / 1000));
}
